import { useEffect } from 'react'

export const useHtmlLang = (lang: string): void => {
  useEffect(() => {
    document.documentElement.lang = lang
  }, [lang])
}
